export default {
    messages: {
        "navbar.links.discover": "Over UBISOFT+",
        "navbar.links.store": "Store",
        "navbar.links.news": "Nieuws",
        "navbar.links.forum": "Forum",
        "navbar.links.support": "Support",
        "navbar.links.status": "Mijn status",
        "navbar.links.featured": "Highlights",
        "navbar.links.rewards": "Verzilver",
        "navbar.links.library": "Alle games",
        "navbar.links.benefits": "UBISOFT+ beloningen",
        "navbar.links.subscription": "Beheer mijn abonnement",
        "navbar.links.cloud": "Cloud available",
        "heading.all_games": "Alle games",
        "heading.my_games": "Blijf spelen",
        "heading.popular_games": "Meest populaire games",
        "heading.recommended_games": "Aanbevolen voor jou",
        "action.load_more_games": "Laad meer",
        "action.search_for_game": "Zoek games",
        "action.launch_game": "Start game",
        "action.activate_game": "Activeer game",
        "filters.brand": "Filter bij brand",
        "filters.game_name": "A - Z",
        "filters.release_date": "Releasedatum",
        "filters.show_all": "Alles weergeven",
        "filters.sort": "Sorteer op",
        "filters.all": "Alles",
        "filters.activated": "Geactiveerd",
        "message.no_activated_games": "Geen geactiveerde games komen overeen met je zoekopdracht",
        "message.already_owned": "Je bezit deze game al",
        "message.no_available_games": "Geen beschikbare games komen overeen met je zoekopdracht",
        "message.no_search_results": "Geen beschikbare games komen overeen met je zoekopdracht",
        "message.error": "Sorry! Er is een fout opgetreden bij het verwerken van je verzoek ",
        "message.refresh_page": "Klik hier om het opnieuw te proberen",
        "message.no_subscription": "Je bent op dit moment niet geabonneerd. Controleer je account details!",
        "warning.savefiles_alert.title": "Belangrijk bericht omtrent opslagbestanden",
        "warning.savefiles_alert.body": "Een upgrade naar de edition die beschikbaar is op UBISOFT+ heeft op je opslagbestanden, inlcusief je huidige voortgang in de game. Als je UBISOFT+ abonnement eindigt, moet je de Season Pass kopen om al je opgeslagen bestanden te laden (inclusief de voortgang in de game). Voor meer informatie, bekijk {here} artikelen.",
        "warning.savefiles_alert.body.here": "deze",
        "warning.savefiles_alert.cancel": "Terug",
        "warning.savefiles_alert.confirm": "Bevestig",
        "warning.mobile_launch_alert.body": "{game} is toegevoegd aan je games. Open Uplay op je pc om te spelen.",
        "footer.copyright": "© {year} Ubisoft Entertainment. All Rights Reserved. Ubisoft, Ubi.com and the Ubisoft logo are trademarks of Ubisoft Entertainment in the U.S. and/or other countries",
        "footer.links.ubi_link_label": "ubisoft.com",
        "footer.links.terms_of_use_label": "Gebruikersvoorwaarden",
        "footer.links.privacy_policy_label": "Privacybeleid",
        "footer.links.legal_label": "Legal",
        "hero.title": "Ubisoft abonnementsservice",
        "hero.subtitle": "Krijg onbeperkt toegang tot 100+ games",
        "hero.buttons.subscribe": "Nu abonneren",
        "hero.buttons.login": "Login",
        "hero.buttons.browse": "Bekijk alle games",
        "progression.benefits.description": "Ontdek onze werelden en verover nieuwe. We willen je loyaliteit belonen! Krijg elke maand nieuwe in-game items.\r\nHoe langer je blijft op Ubisoft+, hoe meer in-game beloningen je kan verzilveren!",
        "progression.benefit.singular.reward": "beloning",
        "progression.benefit.plural.reward": "beloningen",
        "progression.benefit.singular.benefit": "korting",
        "progression.benefit.plural.benefit": "kortingen",
        "progression.benefit.singular.booster": "booster",
        "progression.benefit.plural.booster": "boosters",
        "progression.level.subscribed_for": "Een UBISOFT+ abonnee voor",
        "progression.level.new_subscriber": "Nieuwe abonnee",
        "progression.level.new_subscribers": "Nieuwe abonnees",
        "progression.level.subscription.first_month": "1 Maand",
        "progression.level.subscription.starting_with_months": "{months}+ Maanden",
        "general.date.month": "maand",
        "general.date.months": "maanden",
        "general.date.month_remaining": "maand resterend",
        "general.date.months_remaining": "maanden resterend",
        "rewards.monthly_rewards": "Je maandelijkse beloningen",
        "rewards.trial_info": "Free trial",
        "rewards.left": "{time_left} resterend om deze maand {rewards_left} beloning(en) te verzilveren",
        "rewards.current_title": "Beloningen van deze maand",
        "rewards.previous_title": "Je vorige beloningen",
        "rewards.upcoming_title": "Komende beloningen",
        "rewards.none_found": "Geen beloningen gevonden",
        "rewards.available": "Beschikbaar",
        "rewards.locked": "Vergrendeld",
        "rewards.claimed": "Verzilverd",
        "rewards.claim": "Ja",
        "rewards.cancel": "Annuleer",
        "rewards.confirm": "Wil je deze beloningen verzilveren?",
        "rewards.none_left": "Je hebt alle beloningen voor deze maand verzilverd",
        "rewards.already_claimed": "Je hebt deze beloning al verzilverd",
        "rewards.claim_confirm": "Deze beloning is naar je game verzonden!",
        "rewards.close": "Begrepen!",
        "rewards.load_more": "Laad meer",
        "external.links.actions.go": "Go",
        "external.links.actions.more_info": "More Info",
        "external.links.actions.learn_more": "Learn More"
    }
};